export default __webpack_public_path__ + "static/services-60dbb38967ebb2ea17b9bbb4e558adae.jpg";